import { graphql } from "../gql";

const getEventSummariesQuery = graphql(`
  query GetEventSummaries($seasons: [Int!]!) {
    eventSummaries(seasons: $seasons) {
      numberfireId
      season
      week
      startTime
      homeTeam {
        numberfireId
        name
        shortName
      }
      awayTeam {
        numberfireId
        name
        shortName
      }
      headToHeadSlug
    }
  }
`);

export default getEventSummariesQuery;
